// import React from "react";

// ErrorMessage component displays an error message
// Props:
// - errorText: The text of the error message to display
const ErrorMessage = ({ errorText }): React.JSX.Element => (
  // Render a span element with the error message text and apply the "error-msg" CSS class for styling
  <span className="error-msg">{errorText}</span>
);

export default ErrorMessage;
